import API_URLS from "../../config/BackendConfig";
import { getToken } from "../../utils/tokenUtils";
import { postRequest } from "../../config/AxiosConfig";

const apiBaseUrl = API_URLS.CUSTOMER;

const getAuthHeaders = () => {
  const token = getToken();

  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Add IP Service
export const AddIPService = async ({ ip_address }) => {
  try {
    const payload = {
      ip_address: ip_address,
    };
    const response = await postRequest({
      url: apiBaseUrl + "ip/add",
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log("Error In Adding IP", error.response?.data || error.message);
    throw error;
  }
};
// ENd

// IPService Retrive
export const IPRetriveService = async (page = 1) => {
  try {
    const response = await postRequest({
      url: `${apiBaseUrl}ip/report?page=${page}`,
      headers: getAuthHeaders(),
    });

    return response;
  } catch (error) {
    console.error(
      "Error In Fetching IP Service Details",
      error.response?.data || error.message,
    );
  }
};

// Toggle
export const ToggleStatusService = async ({ ip_id }) => {
  try {
    const payload = {
      ip_id: ip_id,
    };

    const response = await postRequest({
      url: apiBaseUrl + "ip/toggle-status",
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error("Erro in Toggle", error.response?.data || error.message);
  }
};

export const changeAPIKeyGetOTP = async (payload) => {
  try {
    const response = await postRequest({
      url: `${apiBaseUrl}api-key/otp-key`,
      headers: getAuthHeaders(),
      data: payload
    });

    return response;
  } catch (error) {
    console.error(
      "Error In sending otp",
      error.response?.data || error.message,
    );
  }
};

export const changeAPIKeyVerifyOTP = async (payload) => {
  try {
    const response = await postRequest({
      url: `${apiBaseUrl}api-key/verify-otp-key`,
      headers: getAuthHeaders(),
      data: payload
    });

    return response;
  } catch (error) {
    console.error(
      "Error In sending otp",
      error.response?.data || error.message,
    );
  }
};
